export const validateVideoUrl = (url) => {
  // just checking the extension to solve the chrome hang issue for now.

  const splitByDot = url.split('.');
  const extension = splitByDot.slice(-1);
  return `${extension}`.toLowerCase() === 'mp4';
  // const regex = new RegExp('^https?://(?:[a-z0-9\-]+\.)+[a-z]{2,6}(?:/[^/#?]+)+\.(?:mp4)$');
  // return regex.test(url);
};



// WEBPACK FOOTER //
// ./src/utils/video.js